const DEV_API_BASE_URL = "http://localhost:5249/api";
const PROD_API_BASE_URL = "https://irqgyp.vucahost.com/api";

export const getApiBaseUrl = () => {
  const configured = String(process.env.REACT_APP_API_BASE_URL || "").trim();
  if (configured) return configured;
  return process.env.NODE_ENV === "production" ? PROD_API_BASE_URL : DEV_API_BASE_URL;
};

